module.exports = __webpack_public_path__ + "static/media/extra_oral_front.82b1b1f0.png";